<template>
  <div class="toolbar-actions d-inline-block">
    <v-badge
        overlap
        :color="badgeColor"
        :value="mostrarAlerta"
        class="processo-badge"
    >
      <v-tooltip top :open-delay="150" :close-delay="0" slot="badge">
        <span
            slot="activator"
            class="badge-content"
            :style="{ color: badgeTextColor }"
            :aria-label="textoAlerta"
        >!</span>
        <span>{{ textoAlerta }}</span>
      </v-tooltip>

      <v-menu offset-y>
        <v-btn
            slot="activator"
            small
            outline
            color="primary"
            class="action-btn action-btn--outline action-btn--dropdown"
        >
          <span class="label">Processo Digital</span>
          <v-icon right small class="caret ml-0">arrow_drop_down</v-icon>
        </v-btn>

        <v-list dense>
          <v-list-tile @click="acessarProcessoDigital">
            <v-list-tile-title>Acessar</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="acessarEdocs">
            <v-list-tile-title>Enviar E-Docs</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-badge>

    <v-snackbar
        v-model="mostrarAlertaErro"
        :timeout="6000"
        top
        right
        color="warning"
    >
      <v-icon color="white" class="mr-2">warning</v-icon>
      {{ mensagemErro }}
      <v-btn
          flat
          color="white"
          @click="mostrarAlertaErro = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog
        v-model="mostrarEdocsModal"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        class="edocs-dialog"
    >
      <v-card class="edocs-card">
        <v-toolbar dark color="primary" class="edocs-toolbar">
          <v-btn
              icon
              dark
              @click="fecharEdocsModal"
              class="botao-voltar"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>Enviar E-Docs</v-toolbar-title>
        </v-toolbar>
        
        <iframe
            v-if="edocsUrl"
            :src="edocsUrl"
            class="edocs-iframe"
            frameborder="0"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { actionTypes } from '@/core/constants'

export default {
    name: 'AcoesProcessoEdocs',
    props: {
        mostrarAlerta: { type: Boolean, default: false },
        textoAlerta: {
            type: String,
            default: 'Envio para o e-Docs em Processamento'
        },
        status: {
            type: String,
            default: 'warning',
            validator: v => ['warning', 'error'].includes(v)
        },
        processoVirtualUrl:  {
            type: String,
            default: ''
        },
        processoVirtual: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            mostrarAlertaErro: false,
            mensagemErro: '',
            mostrarEdocsModal: false,
            edocsUrl: ''
        }
    },
    computed: {
        badgeColor () {
            return this.status === 'error' ? 'red accent-3' : 'amber accent-3'
        },
        badgeTextColor () {
            return this.status === 'error' ? '#ffffff' : '#1565c0'
        }
    },
    methods: {
        async acessarProcessoDigital () {
            try {
                const data = await this.$store.dispatch(actionTypes.COMPRADOR.ACESSAR_EDOCS, this.processoVirtual)

                if (data && data.url) {
                    window.location.href = data.url
                }
            } catch (error) {
                if (error.response && error.response.status === 500) {
                    this.mensagemErro = 'Não é possível acessar o processo no e-Docs pois ainda não foi enviado nenhum documento.'
                    this.mostrarAlertaErro = true
                } else {
                    this.mensagemErro = 'Erro ao tentar acessar o processo digital. Tente novamente.'
                    this.mostrarAlertaErro = true
                }
            }
        },
        acessarEdocs () {
            const host = window.location.protocol + '//' + window.location.host
            this.edocsUrl = host + '/flowbee/#/processos/' + this.processoVirtual + '/sincronizacao/e-docs'
            this.mostrarEdocsModal = true
        },
        fecharEdocsModal () {
            this.mostrarEdocsModal = false
            this.edocsUrl = ''
            window.location.reload()
        }

    }
}
</script>

<style>
.toolbar-actions .action-btn {
  height: 28px;
  line-height: 32px;
  margin: 0;
  margin-right: 20px;

  padding: 0 10px;
  min-width: 0;

  text-transform: none;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: .2px;
}
.toolbar-actions .action-btn .v-btn__content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.toolbar-actions .action-btn .v-icon {
  font-size: 18px;
  line-height: 1;
}

.toolbar-actions .action-btn--outline.theme--light.v-btn.v-btn--outline {
  border-width: 1px !important;
}

.toolbar-actions .action-btn:before {
  display: none;
}

.toolbar-actions .action-btn:hover {
  background: rgba(33,150,243,.08);
}

.processo-badge .v-badge__badge {
  top: -8px;
  right: 10px;
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(0,0,0,.2);
}
.badge-content{
  color:#1565c0;
  display:inline-block;
  width:16px;
  text-align:center;
  cursor: default;
  user-select: none;
}

.toolbar-actions .v-badge,
.toolbar-actions .v-menu {
  vertical-align: middle;
}

/* Estilos para o modal E-Docs */
.edocs-dialog .v-dialog {
  margin: 0 !important;
  max-height: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  height: 100% !important;
}

.edocs-card {
  height: 100vh !important;
  max-height: 100vh !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.edocs-iframe {
  width: 100% !important;
  height: calc(100vh - 64px) !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  top: 64px !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

.edocs-toolbar {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  z-index: 10 !important;
  margin: 0 !important;
  padding: 0 16px !important;
  height: 64px !important;
  max-width: none !important;
}

.botao-voltar {
  margin-right: 8px;
}

.botao-voltar:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
